import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { communicationsStakeholdersRoute } from '@atlassian/jira-router-routes-communications-routes/src/communicationsStakeholdersRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { stakeholdersPageEntrypoint } from './ui/stakeholders/stakeholdersPageEntrypoint.tsx';

export const communicationsStakeholdersRouteEntry = createEntry(
	communicationsStakeholdersRoute,
	() => ({
		group: 'communications',
		navigation: {
			menuId: MENU_ID.COMMUNICATIONS,
			sidebar: AsyncSidebarServicedesk,
		},
		entryPoint: () => {
			return fg('communications_stakeholder_management_platform')
				? stakeholdersPageEntrypoint
				: undefined;
		},
		resources: [...getNavigationResources()],
	}),
);
